import { render, staticRenderFns } from "./FreePayment.vue?vue&type=template&id=587ffb30&scoped=true"
import script from "./FreePayment.vue?vue&type=script&lang=js"
export * from "./FreePayment.vue?vue&type=script&lang=js"
import style1 from "./FreePayment.vue?vue&type=style&index=1&id=587ffb30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ffb30",
  null
  
)

export default component.exports